import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const StyledSpan=styled.span`
    padding-left: 2px;
    padding-right: 2px;
    margin: 2px;
    font-size: 70%;
    color: #ddd;
    overflow-wrap: anywhere; 
`;

function PresenceIcon(props) {
    return (
        <StyledSpan>
            <FontAwesomeIcon icon={faUser} size="sm" fixedWidth/> {props.nick_name}
        </StyledSpan>
    );
}

export default PresenceIcon;
